import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class TmsWebBaseDragAndDropService extends BaseService {
  constructor(protected baseRoute: string, protected httpService: HttpService) {
    super(baseRoute, httpService);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
